// extracted by mini-css-extract-plugin
module.exports = {"logo":"MenuLogo_logo__3xd4E"};